import { useAuthStore } from '@/lib/auth-store';

/** True when persisted auth has hydrated and checkAuth is not in flight. */
export function useAuthReady(): boolean {
  const { _hasHydrated, authChecking } = useAuthStore();
  return _hasHydrated && !authChecking;
}
